import { apiSlice } from "@/shared/api/api-slice"
import type { CreateTopupInvoiceRequest, CreateTopupInvoiceResponse } from "@/shared/types/api/business-mode.types"

import { mapBusinessSubscriptionError } from "./error-mapping"

export const createTopupInvoiceApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessSubscription", "BusinessUsageStats", "TopupPacks"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      createTopupInvoice: builder.mutation<CreateTopupInvoiceResponse, CreateTopupInvoiceRequest>({
        query: request => ({
          url: `/api/v1/business/subscriptions/topup`,
          method: "POST",
          body: request
        }),
        transformErrorResponse: mapBusinessSubscriptionError,
        invalidatesTags: [{ type: "BusinessSubscription" as const }, { type: "BusinessUsageStats" as const }]
      })
    })
  })

export const { useCreateTopupInvoiceMutation } = createTopupInvoiceApi
